import Env from '../base/env'
import gsap from 'gsap'
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import SplitText  from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(SplitText);

export default class RevealHome
{
  constructor(view)
  {
    this.DOM = {
      view : view
    }
    this.DOM.layoutA = this.DOM.view.querySelector('.layout-a')
    this.DOM.layoutBasic = this.DOM.view.querySelectorAll('.fxView-basic')
    this.DOM.layoutContact = this.DOM.view.querySelectorAll('.fxView-contact')
    this.DOM.layoutArticles = this.DOM.view.querySelectorAll('.fxView-article')
    this.DOM.layoutDark = this.DOM.view.querySelectorAll('.fxDark-ui')

    this.animateLayoutA()
    this.animateLayoutBasic()
    this.animateLayoutContact()
    this.animateLayoutArticles()
    this.animateDarkUi()
  }

  animateLayoutA()
  {
    const tl = gsap.timeline()
    const $desc = this.DOM.layoutA.querySelector('.fxDesc')


    gsap.fromTo($desc , { autoAlpha: 0 } , { autoAlpha : 1 , ease:'cubic.out' , duration:1 ,   scrollTrigger : {
        trigger: $desc,
        start: `top bottom-=5%`,
        scroller: Env.framework.UI.DOM.locoScroll,
        pin: false,
        markers: false,
      }
    })

    const st = ScrollTrigger.create({
      trigger: $desc,
      start: `top top+=100px`,
      scroller: Env.framework.UI.DOM.locoScroll,
      pin: false,
      markers: false,
      onEnter:()=>{
        Env.$html.classList.add('ui-dark')
      },
      onEnterBack:()=>{
        Env.$html.classList.add('ui-dark')
      },
      onLeave:()=>{
        // Env.$html.classList.remove('ui-dark')
      },
      onLeaveBack:()=>{
        Env.$html.classList.remove('ui-dark')
      }
    })
  }

  animateLayoutBasic()
  {
    for(let $layout of this.DOM.layoutBasic) {
      const $txts = new SplitText($layout.querySelectorAll('.fxText'),{type:'lines'})
      const $desc = $layout.querySelectorAll('.fxDesc')
      const $visuals = $layout.querySelectorAll('.fxVisual')

      const tl = gsap.timeline({
        scrollTrigger : {
          trigger: $layout,
          start: `top top+=200px`,
          scroller: Env.framework.UI.DOM.locoScroll,
          pin: false,
          markers: false,
        }
      })


      tl.add([
        gsap.fromTo($desc , { autoAlpha: 0 , y : 30} , { autoAlpha : 1 , y: 0 , ease:'cubic.out' , duration:1 , stagger:.1 }),
        gsap.fromTo($txts.lines , { autoAlpha: 0 , y : 30 } , { autoAlpha : 1 , y: 0 , ease:'cubic.out' , duration:1, stagger:.1 }),
      ])
      if($visuals.length) {
        for(const $visual of $visuals) {
          gsap.fromTo($visual, { autoAlpha : 0 } , { autoAlpha :1 , ease:'power4.out' , duration: 2 , scrollTrigger :
            {
              trigger:$visual,
              start: `top 75%`,
              scroller: Env.framework.UI.DOM.locoScroll,
            }
          })
        }
      }

    }
  }

  animateLayoutContact()
  {
    for(let $layout of this.DOM.layoutContact) {
      const $desc = $layout.querySelectorAll('.fxDesc')
      const $block = $layout.querySelectorAll('.fxBlock')

      const tl = gsap.timeline({
        scrollTrigger : {
          trigger: $layout,
          start: `top 75%`,
          scroller: Env.framework.UI.DOM.locoScroll,
          pin: false,
          markers: false,
        }
      })

      tl.add([
        gsap.fromTo($desc , { autoAlpha: 0 , y : 30} , { autoAlpha : 1 , y: 0 , ease:'cubic.out' , duration:1 , stagger:.1 }),
        gsap.fromTo($block , { autoAlpha: 0 , y : 30 } , { autoAlpha : 1 , y: 0 , ease:'cubic.out' , duration:1, delay:.2 }),
      ])
    }
  }

  animateLayoutArticles()
  {
    for(let $layout of this.DOM.layoutArticles) {
      const $desc = $layout.querySelectorAll('.fxDesc')
      const $block = $layout.querySelectorAll('.fxBlock')

      const tl = gsap.timeline({
        scrollTrigger : {
          trigger: $layout,
          start: `top 60%`,
          scroller: Env.framework.UI.DOM.locoScroll,
          pin: false,
          markers: false,
        }
      })

      tl.add([
        gsap.fromTo($desc , { autoAlpha: 0 , y : 30} , { autoAlpha : 1 , y: 0 , ease:'cubic.out' , duration:1 , stagger:.1 }),
        gsap.fromTo($block , { autoAlpha: 0 , y : 30 } , { autoAlpha : 1 , y: 0 , ease:'cubic.out' , duration:1, delay:.2, stagger:.2 }),
      ])
    }
  }

  animateDarkUi()
  {
    for(let $layout of this.DOM.layoutDark) {

      const st = ScrollTrigger.create({
        trigger: $layout,
        start: `top top+=100px`,
        scroller: Env.framework.UI.DOM.locoScroll,
        pin: false,
        markers: false,
        onEnter:()=>{
          Env.$html.classList.add('ui-dark')
          console.log('enter');
        },
        onLeaveBack:()=>{
          Env.$html.classList.remove('ui-dark')
        }
      })

    }
  }
}
